import React, { useContext, useState } from "react";
import "../../../css/home/home.css"; // Asegúrate de crear este archivo CSS también
import ColorsMain from "../../../colors/ColorsMain";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../button/ButtonWhite";
import InputLogin from "../../inputs/InputLogin";

const NameCompany = ({ setCompanyName, onClick, errorMesagge = false, companyName }) => {
  const { language } = useContext(UtilContext); // Usa el contexto de Auth



  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="flex justify-evenly flex-col gap-2 w-full"
    >
      <div className="flex flex-col">
        <p className="text-2xl md:text-3xl mt-6 md:mt-8" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].name_businnes.title}
        </p>
        <p className="text-[#E4E4E4] text-[14px] mt-2 mb-6 md:mb-8">
          {GLOBAL_LANGUAGE[language].name_businnes.subtitle}
        </p>
        <p style={{ color: ColorsMain.textSecundary }} className="mb-1">
          {GLOBAL_LANGUAGE[language].name_businnes.label_empresa}
        </p>
        <InputLogin
          error={errorMesagge}
          value={companyName}
          onChange={(e) => setCompanyName(e)}
          label={GLOBAL_LANGUAGE[language].name_businnes.label_empresa}
          placeholder={GLOBAL_LANGUAGE[language].name_businnes.placeholder_empresa}
        />
        {errorMesagge && (
          <div className="w-full flex flex-col mt-1">
            <p className="text-[#FF928B] text-[13px]">{GLOBAL_LANGUAGE[language].name_businnes.error_name_company}</p>
          </div>
        )}
        <div className="flex flex-row justify-end mb-1 mt-6">
          <ButtonWhite
            onClick={onClick}
            label={GLOBAL_LANGUAGE[language].name_businnes.label_button}
            className="w-full md:w-fit"
          />
        </div>
      </div>
      <div className="w-full h-[1px] bg-[#5E5E63] mt-8 md:mt-10" />
      <p style={{ color: ColorsMain.textSecundary }} className="text-sm">
        {GLOBAL_LANGUAGE[language].name_businnes.posdata}
      </p>
    </div>
  );
};

export default NameCompany;
